import React from "react";
import { FiMapPin } from "react-icons/fi";
import Logo from "../styles/Black-SVG-Landscape.svg";
import JuanEstebanPhoto from "../candidates/keisy1.jpeg"

export default function SocialMediaCreativeStrategistKeisy() {
  const candidateProfileCopy = {
    name: "Keisy",
    location: "Bogotá, Colombia",
    compensation: {
      range: "$20 USD / hourly",
    },
    availability: "Available to start immediately",

    working_style:
      "Keisy is a hands-on DTC content strategist and creator who approaches every content decision as a subscriber conversion problem first, a production problem second. She structures content around funnel stages with clear metric ownership at each layer, embeds CTAs naturally within high-intent content, and builds curiosity loops to move audiences from scrolling to subscribing. She has direct experience navigating restricted-ad platforms for products that can't run paid ads, which is the exact constraint that defines this role. Her 5+ years span DTC e-commerce content strategy, short-form video production, graphic design, hook writing, and organic growth systems for physical product brands.",

    loom_video_link: "https://fathom.video/share/-DihUmWsz9syds8opcrfH855xuxvWpgB",

    tools: [
      {
        category: "Content Strategy & Subscriber Conversion",
        items: [
          "Full-funnel content architecture (Discovery, Nurture, Conversion) with metric ownership per layer",
          "Subscriber conversion strategy: value exchanges, curiosity loops, embedded CTAs within high-intent content",
          "Content calendar management in 2 to 4 week cycles with format, platform, funnel stage, and CTA per asset",
          "Competitor and trend research via TikTok Ad Library and Meta Ad Library, filtered by conversion not just engagement",
        ],
      },
      {
        category: "Platforms & Publishing Ops",
        items: [
          "TikTok, Instagram, YouTube Shorts (content creation, publishing, algorithm optimization)",
          "Meta Business Suite and Meta Ads Manager (scheduling, analytics, campaign management)",
          "TikTok Ads (campaign management and platform-native ad creation)",
          "Google Analytics and HubSpot CRM (performance tracking, audience behavior, lead management)",
        ],
      },
      {
        category: "Content Production & Design",
        items: [
          "CapCut and Adobe Creative Suite (short-form video editing and graphic production)",
          "Canva Pro (social media graphics, branded carousels, product imagery, infographics)",
          "Platform-native editing: captions, B-roll, pacing, sound design with hook-first structure for 3 to 4 second scroll stop",
          "Visual identity maintenance across multiple formats, platforms, and brands",
        ],
      },
      {
        category: "AI Tools & Workflow",
        items: [
          "ChatGPT, Claude, CapCut AI, Canva AI, Notion AI (research, scripting, editing, planning)",
          "Pro-AI adoption attitude: learns and integrates new tools as a working principle",
        ],
      },
    ],

    soft_skills: [
      "5+ years of DTC e-commerce content strategy and hands-on creative production",
      "Systems thinker: structures content around subscriber conversion outcomes, not just engagement",
      "Direct experience navigating restricted-ad platforms (pheromones, same restrictions as hemp/cannabis)",
      "Metric-accountable: tracks engagement, retention, and conversion metrics and iterates based on data",
      "Organized and self-directed: owns the content calendar independently without depending on founder bandwidth",
      "Bilingual (English C1 / Spanish native) with professional use in content creation and client communication",
    ],

    about_candidate:
      "Keisy is a DTC content strategist and hands-on creator with 5+ years building organic growth systems for e-commerce brands. She approaches every content decision as a subscriber conversion problem: what stops the scroll, what moves the viewer to the email list, and what makes subscribing feel indispensable. She has led the full creative and marketing strategy for a DTC e-commerce brand, personally handling short-form video, static visuals, hook scripting, daily competitor research, and organic funnel building. She is the only candidate in this group with direct experience in restricted-ad product categories.",

    core_strengths: [
      {
        headline: "Subscriber conversion-first content strategy",
        description:
          "Structures every content decision around the content-to-subscriber pipeline. Designs value exchanges, embeds natural CTAs within high-intent content, and builds curiosity loops that push viewers to the newsletter. This is the exact mindset the role's #1 metric demands.",
      },
      {
        headline: "Direct restricted-ad platform experience",
        description:
          "Has navigated platform ad restrictions identical to hemp and cannabis, working with pheromone products restricted on Meta, Google, and TikTok. Understands that organic content plus email is the entire acquisition engine. The only candidate in this group with this operational experience.",
      },
      {
        headline: "Full-scope DTC content execution, from strategy through production",
        description:
          "Led creative and marketing for a DTC e-commerce brand: short-form video, static visuals, carousel design, hook scripting, daily competitive research, and organic funnel building. The complete scope of the role, executed by one person.",
      },
      {
        headline: "90-day framework aligned with the role's success milestones",
        description:
          "Competitive audit and content pillars in month one, consistent publishing and format testing in month two, metric-driven optimization in month three. Mirrors the role's 30/60/90-day criteria closely.",
      },
    ],

    relevant_experience: [
      {
        headline: "Marketing & Creative Director | RV E-COM SAS | 2022 to 2025",
        bullets: [
          "Led creative and marketing strategy for a DTC e-commerce brand targeting audiences in Mexico and Colombia",
          "Created short-form video content optimized for TikTok, Instagram Reels, and Meta platforms",
          "Scripted hooks and story-driven content designed to stop scrolling within 3 to 4 seconds",
          "Designed static visuals, product graphics, and branded social media carousels",
          "Built organic content strategies guiding audiences from social discovery to email subscriptions and product conversions",
          "Conducted daily trend research and competitor analysis to identify high-performing DTC content formats",
        ],
      },
      {
        headline: "Founder & Marketing Manager | E-commerce Brand | 2020 to 2022",
        bullets: [
          "Owned end-to-end marketing and content strategy for a physical product e-commerce brand across Latin American markets",
          "Produced short-form videos, product visuals, and promotional graphics for digital campaigns",
          "Managed influencer collaborations and content production workflows",
        ],
      },
      {
        headline: "Affiliate Marketing Team Lead | BE Financial Education | 2022 to 2024",
        bullets: [
          "Coordinated distributed teams responsible for digital marketing campaigns",
          "Built reporting systems tracking engagement, conversions, and campaign performance",
        ],
      },
    ],
  };

  const technicalAssessment = {
    meta: {
      role: "Social Media Creative Strategist, Frizo / LGO Brands",
      interviewDate: "March 16, 2026",
      analyst: "AI-Architechs Senior Technical Hiring Analysis",
    },

    snapshot:
      "Keisy is the most naturally aligned candidate with the three-metric framework that defines this role. 5+ years of hands-on DTC content experience, the only restricted-ad platform experience in this group, and the strongest subscriber conversion thinking. Her production spans short-form video, static design, carousels, and hook writing. The strongest overall fit for building the content-to-subscriber pipeline from day one.",

    scorecard: [
      {
        dimension: "Content Production & Visual Identity",
        score: 8,
        rationale:
          "Created short-form video, static visuals, product graphics, and branded carousels for a DTC e-commerce brand. Uses Canva Pro, Adobe Creative Suite, and CapCut. Has produced content for physical product brands, not just managed it. Most complete video-plus-design combination in this group. Solid, not cinematic-level, but above the bar for building a brand presence from zero.",
      },
      {
        dimension: "Content-to-Subscriber Pipeline Thinking",
        score: 9,
        rationale:
          "Strongest pipeline thinker in this group. Described value exchanges, curiosity loops, embedded CTAs within high-intent content, and making the email list feel indispensable. Not generic CTA advice but a layered conversion strategy built on audience psychology. Exactly the mindset the role demands.",
      },
      {
        dimension: "Full-Funnel Content Strategy",
        score: 9,
        rationale:
          "90-day phased approach that mirrors the role's 30/60/90 milestones: research and pillars in month one, publishing and testing in month two, metric-driven optimization in month three. Defined content pillars and mapped them to funnel stages with clear purpose. Most structured and role-aligned strategy answer in this group.",
      },
      {
        dimension: "Scripting, Hook Writing & Copywriting",
        score: 8,
        rationale:
          "Analyzes hooks across three dimensions: curiosity/surprise, connection to a real audience problem, and platform-native feel. Gave a concrete hook example for the wellness niche. Creates script frameworks and talking points for efficient founder filming sessions. Handles captions, on-screen text, and basic email copy. Covers the full copywriting scope the role requires.",
      },
      {
        dimension: "Founder Coaching & On-Camera Direction",
        score: 8,
        rationale:
          "Understood that the founder's experience is the most valuable asset and the strategist's job is to extract and direct it. Proposed educational videos, behind-the-scenes lab content, and industry myth-busting. Creates script frameworks so filming sessions are efficient. Her instinct and philosophy are the most aligned with what the founder described wanting.",
      },
      {
        dimension: "Competitive Research & Cross-Category Intelligence",
        score: 8,
        rationale:
          "Uses TikTok Ad Library and Meta Ad Library filtered by conversion, not just engagement. Organizes insights in Notion and Airtable. Daily trend research and competitor analysis as an operational habit. Approaches research analytically, consistent with the role's requirement to study the best DTC brands and articulate why specific content works.",
      },
      {
        dimension: "Metrics Accountability & Performance Optimization",
        score: 9,
        rationale:
          "Named all three metric categories and connected them to business outcomes without being prompted. Gave a practical diagnostic example: strong reach but low retention means the hook works but the video structure needs improvement. Described how she'd test and iterate. This is the data-driven feedback loop the role demands.",
      },
      {
        dimension: "Regulated/Restricted-Ad Industry Readiness",
        score: 9,
        rationale:
          "Only candidate with direct restricted-ad experience. Worked with pheromone products facing identical restrictions as hemp and cannabis on Meta, Google, and TikTok. Understands platform compliance from operational experience. Proposed balancing education, transparency, and compliance through founder-led content and organic hooks. The single most differentiating qualification in this group.",
      },
      {
        dimension: "AI Tools & Workflow Efficiency",
        score: 7,
        rationale:
          "Uses ChatGPT, CapCut AI, Canva AI, Notion AI, and Claude. Genuine openness to adopting new tools quickly. Functional across the standard content creator AI toolchain. Not building custom AI workflows, but solidly meets the bar and shows the pro-AI adoption mindset the role calls for.",
      },
    ],

    strengths: [
      {
        headline: "Strongest content-to-subscriber conversion thinker in this group",
        description:
          "Every answer circled back to moving audiences from social content to email lists. Value exchanges, curiosity loops, embedded CTAs, making the newsletter feel indispensable. Not buzzwords but an integrated strategy she's clearly executed before. The most valuable signal for a role where subscriber conversion is the #1 metric.",
      },
      {
        headline: "Only candidate with direct restricted-ad platform experience",
        description:
          "Has navigated the exact constraint that defines this role: building organic strategies for products that can't run paid ads. Experience with pheromone products (restricted on Meta, Google, TikTok) means she understands that organic plus email is the entire acquisition engine.",
      },
      {
        headline: "DTC execution across the full scope of the role",
        description:
          "Led creative and marketing for a DTC brand: short-form video, static visuals, carousels, hook scripting, competitor research, and organic funnel building. Not strategy-only experience. She's done the actual daily work this role requires.",
      },
      {
        headline: "90-day framework mirrors the role's milestones",
        description:
          "Audit and pillars in month one, publishing and testing in month two, metric-driven optimization in month three. Aligns closely with the 30/60/90-day criteria, suggesting smooth onboarding.",
      },
      {
        headline: "Analytical hook and retention optimization",
        description:
          "Evaluates hooks across curiosity, audience problem connection, and platform-native feel. Monitors retention curves to diagnose underperformance. Tests and iterates based on data. The metrics accountability pattern the role requires.",
      },
      {
        headline: "Hemp and cannabis myth-busting content instinct",
        description:
          "Without being prompted, identified that hemp and cannabis is full of myths and proposed myth-busting as a content format. Directly relevant to Frizo's need to educate consumers about crystalline cannabinoid extraction. Shows she's already thinking about how to turn Chad's product story into trust-building content.",
      },
    ],

    flags: [
      {
        headline: "CV impact numbers are general and worth exploring in conversation",
        description:
          "Outcomes like 'consistent high-volume product sales' without specific before/after numbers. The analytical framework is clearly there, so it's about getting her to quantify her results in conversation.",
      },
      {
        headline: "English copywriting fluency is worth assessing directly",
        description:
          "English is C1 Professional and her interview showed competent communication. Since the content will be in English, worth getting a feel for her writing voice in conversation to confirm it meets the bar.",
      },
      {
        headline: "Affiliate marketing role is less directly relevant",
        description:
          "Her BE Financial Education role (2022 to 2024) was team coordination and digital campaigns in a financial education context. Not a concern, just less relevant. Overlaps with her DTC work, so helpful to understand how she balanced both.",
      },
    ],

    when_to_hire: [
      "You want the candidate most ready to build the content-to-subscriber pipeline from day one.",
      "Restricted-ad industry experience matters and you value someone who's navigated it through real work.",
      "You need a hands-on creator who writes, edits, designs, and publishes, and can hold the full content operation solo.",
      "The three-metric framework is central to how you'll evaluate performance, and you want someone who naturally thinks that way.",
    ],

    when_to_be_cautious: [
"You need elite-level cinematic video production from day one. Keisy's production is solid and functional, not premium-agency tier.",
      "Deep AI automation workflows are a core requirement. Her AI usage is functional and willing but not architecturally sophisticated.",
    ],

    bottom_line:
      "Keisy is the top-ranked candidate. Strongest subscriber conversion thinking, only restricted-ad experience in this group, hands-on DTC production across the full scope of the role, and a strategic framework that mirrors the role's milestones. Her production quality is solid rather than elite, and her English writing fluency is worth exploring in conversation, but her overall alignment with what Chad needs is the clearest in this group.",
  };


  // Score pill helper
  const ScorePill = ({ score }) => {
    let bg = "#f97316";
    if (score >= 8) bg = "#22c55e";
    else if (score >= 6) bg = "#36D1FF";
    return (
      <span
        style={{ backgroundColor: bg }}
        className="inline-block text-white text-xs font-bold px-3 py-1 rounded-full"
      >
        {score} / 10
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-[#01014C] text-white flex flex-col items-center py-10 px-4">

      {/* ===================== PAGE 1 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row relative">

        {/* LEFT COLUMN */}
        <aside className="relative md:w-1/3 bg-gradient-to-b from-[#01014C] via-[#0A0A80] to-[#36D1FF] p-8 flex flex-col items-center text-center overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-[#36D1FF]/30 to-transparent"></div>

          {/* Avatar */}
          <div className="relative mb-4">
            <div className="absolute inset-0 rounded-full bg-[#36D1FF]/20 blur-2xl"></div>
            <img
              src={JuanEstebanPhoto}
              alt={candidateProfileCopy.name}
              className="relative w-36 h-36 rounded-full object-cover border-4 border-[#36D1FF] shadow-lg"
            />
          </div>

          {/* Name */}
          <h1 className="text-2xl font-semibold mb-1 text-[#FFFDFB]">
            {candidateProfileCopy.name}
          </h1>

          {/* Location */}
          <div className="flex items-center gap-2 text-[#E0F7FF] text-sm mb-6 opacity-90">
            <FiMapPin className="text-[#36D1FF]" />
            <span>{candidateProfileCopy.location}</span>
          </div>

          {/* Compensation */}
          <div className="bg-[#01014C] border border-[#36D1FF]/50 rounded-xl p-4 w-full text-left mb-4">
            <p className="text-[#B3E9FF] text-sm font-semibold uppercase mb-1">
              Compensation
            </p>
            <p className="text-[#36D1FF] text-lg font-bold">
              {candidateProfileCopy.compensation.range}
            </p>
          </div>

          {/* Availability */}
          <div className="bg-[#01014C] border border-[#36D1FF]/30 rounded-xl p-4 w-full text-left mb-6">
            <p className="text-[#E0F7FF] text-sm">
              {candidateProfileCopy.availability}
            </p>
          </div>

          {/* Video Intro */}
          {candidateProfileCopy.loom_video_link && (
            <div className="w-full mt-4">
              <a
                href={candidateProfileCopy.loom_video_link}
                target="_blank"
                rel="noreferrer"
                className="block w-full text-center font-semibold py-3 rounded-lg
                           bg-[#36D1FF] text-[#01014C]
                           hover:bg-[#5FE2FF]
                           transition-all duration-300"
              >
                🎥 Watch Interview
              </a>
            </div>
          )}


          {/* Tools */}
          <div className="w-full mt-8 mb-6 text-left">
            <h3 className="text-sm font-semibold mb-3 text-[#B3E9FF] uppercase">
              Tools
            </h3>
            {candidateProfileCopy.tools.map((group, i) => (
              <div key={i} className="mb-4">
                <p className="text-xs font-semibold text-[#36D1FF] mb-1 uppercase tracking-wide">
                  {group.category}
                </p>
                <ul className="space-y-1">
                  {group.items.map((tool, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-2 text-xs text-[#E0F7FF]/90 leading-snug"
                    >
                      <span className="mt-1 w-1.5 h-1.5 rounded-full bg-[#36D1FF] shrink-0" />
                      {tool}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Soft Skills */}
          <div className="w-full mb-6 text-left">
            <h3 className="text-sm font-semibold mb-2 text-[#B3E9FF] uppercase">
              Soft Skills
            </h3>
            <ul className="list-disc pl-5 space-y-1 text-[#E0F7FF] text-sm">
              {candidateProfileCopy.soft_skills.map((skill, i) => (
                <li key={i}>{skill}</li>
              ))}
            </ul>
          </div>

          {/* Logo */}
          <div className="w-full mt-8 flex justify-center">
            <img src={Logo} alt="AI-Architechs Logo" className="w-42 opacity-80" />
          </div>
        </aside>

        {/* RIGHT COLUMN */}
        <main className="flex-1 p-10 text-[#01014C] space-y-10">
          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              About this Candidate
            </h2>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {candidateProfileCopy.about_candidate}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Core Strengths
            </h2>
            <div className="grid md:grid-cols-2 gap-6">
              {candidateProfileCopy.core_strengths.map((item, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold mb-1">{item.headline}</p>
                  <p className="text-sm text-gray-700">{item.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 border-b border-[#36D1FF]/40 pb-1">
              Relevant Experience
            </h2>
            <div className="space-y-6">
              {candidateProfileCopy.relevant_experience.map((exp, i) => (
                <div key={i} className="border border-[#36D1FF]/30 rounded-xl p-5">
                  <p className="font-semibold text-[#EB5D2A] mb-2">{exp.headline}</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm text-gray-700">
                    {exp.bullets.map((b, j) => (
                      <li key={j}>{b}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>
        </main>
      </div>

      {/* ===================== PAGE BREAK BAND ===================== */}
      <div className="w-full py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="h-10 rounded-2xl bg-gradient-to-r from-[#01014C] via-[#0A0A80] to-[#36D1FF] opacity-70 shadow-[0_0_40px_#36D1FF20]" />
        </div>
      </div>

      {/* ===================== PAGE 2 ===================== */}
      <div className="w-full max-w-6xl bg-[#FFFDFB] rounded-3xl overflow-hidden shadow-2xl pb-2">
        <main className="p-10 text-[#01014C]">
          <div className="border border-[#36D1FF]/25 rounded-2xl p-6 bg-white shadow-[0_0_12px_#36D1FF15]">

            {/* Header */}
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-2 mb-6">
              <h2 className="text-2xl font-semibold text-[#01014C]">
                Technical Analysis
              </h2>
              <div className="flex flex-col items-start md:items-end gap-1 text-xs text-gray-400">
                <span>{technicalAssessment.meta.role}</span>
                <span>Interview: {technicalAssessment.meta.interviewDate}</span>
                <span>{technicalAssessment.meta.analyst}</span>
              </div>
            </div>

            {/* Snapshot */}
            <div className="border border-[#36D1FF]/20 rounded-xl p-5 bg-[#36D1FF]/5 mb-6">
              <p className="text-base font-bold text-[#01014C] mb-2">Executive Fit Snapshot</p>
              <p className="text-gray-700 text-base leading-relaxed whitespace-pre-line">
                {technicalAssessment.snapshot}
              </p>
            </div>

            {/* Strengths & Flags */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">

              {/* Strengths */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Strengths
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.strengths.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#22c55e]/30 rounded-xl p-4 bg-[#22c55e]/5"
                    >
                      <p className="font-semibold text-sm text-[#01014C] mb-1">
                        {item.headline}
                      </p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Flags */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Flags / Watch-outs
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.flags.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#f97316]/30 rounded-xl p-4 bg-[#f97316]/5"
                    >
                      <p className="font-semibold text-sm text-[#01014C] mb-1">
                        {item.headline}
                      </p>
                      <p className="text-sm text-gray-700">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Scorecard */}
            <div className="mb-6">
              <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                Quantitative Scorecard
              </h3>
              <div className="overflow-x-auto rounded-xl border border-[#36D1FF]/25">
                <table className="w-full text-sm">
                  <thead className="bg-[#36D1FF]/10 text-[#01014C]">
                    <tr>
                      <th className="text-left font-semibold px-4 py-3">Dimension</th>
                      <th className="text-left font-semibold px-4 py-3 w-[120px]">Score</th>
                      <th className="text-left font-semibold px-4 py-3">Rationale</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#36D1FF]/15">
                    {technicalAssessment.scorecard.map((row, idx) => (
                      <tr key={idx} className="bg-white">
                        <td className="px-4 py-3 font-medium text-[#01014C] align-top">
                          {row.dimension}
                        </td>
                        <td className="px-4 py-3 align-top">
                          <ScorePill score={row.score} />
                        </td>
                        <td className="px-4 py-3 text-gray-700 whitespace-pre-line align-top">
                          {row.rationale}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* When to Hire / Considerations */}
            <div className="grid md:grid-cols-2 gap-6 mb-6">

              {/* When to Hire */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ✅ Hire Juan Esteban if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_hire.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#36D1FF]/30 rounded-xl p-4 bg-[#36D1FF]/5 text-sm text-gray-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* When to Be Cautious */}
              <div>
                <h3 className="text-sm font-semibold text-[#01014C] mb-3 uppercase tracking-wide">
                  ⚠️ Be cautious or pass if…
                </h3>
                <div className="space-y-3">
                  {technicalAssessment.when_to_be_cautious.map((item, i) => (
                    <div
                      key={i}
                      className="border border-[#f59e0b]/30 rounded-xl p-4 bg-[#f59e0b]/5 text-sm text-gray-700"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Bottom Line */}
            <div className="border border-[#01014C]/20 rounded-xl p-5 bg-[#01014C]/5">
              <p className="text-sm font-bold text-[#01014C] mb-2 uppercase tracking-wide">
                🏁 Bottom Line
              </p>
              <p className="text-gray-700 text-sm leading-relaxed">
                {technicalAssessment.bottom_line}
              </p>
            </div>

          </div>
        </main>
      </div>

    </div>
  );
}
